export default ({...props}) => {
  const {width, height} = props
  const {palette} = props.theme

  return `
    ${width ? `width: ${width}px;` : ''}
    ${height ? `height: ${height}px;` : ''}
    &[ap_color='white']{
      fill: ${palette.common.white};
    }
    &[ap_color='black']{
      fill: ${palette.common.black};
    }
    &[ap_color='action']{
        
    }
    &[ap_color='disabled']{
        
    }
    &[ap_color='primary']{
        
    }
    &[ap_color='secondary']{
        
    }
    &[ap_color='error']{
      
    }
    &[ap_color='info']{
        
    }
    &[ap_color='success']{
        
    }
    &[ap_color='warning']{
        
    }
  `
}

export const svgWrapperStyles = ({...props}) => {
  const {palette, size, themeGrey} = props.theme
  return `
    display: flex;
    min-width: ${size(1)}px;
    min-height: ${size(1)}px;

    &[ap_type="edit"],
    &[ap_type="checkSelected"],
    &[ap_type="navigateNext"],
    &[ap_type="navigatePrevious"]{
      & svg > *{
       fill:${palette.primary.main};
      }
      }
    &[ap_type="arrowBack"],
    &[ap_type="package"],
    &[ap_type="bullet"]
    {
      & svg > *{
     fill:${themeGrey.medium_emphasis_grey};
      }
    }
    &[ap_type="errorBoundary"] {
      & svg {
      width: ${size(8)}px;
      height: ${size(8)}px;
        & > * {
          fill: ${palette.error.main};
        }
      }
    }
  `
}
